/************
 * Service Class 
 * File Name ...: qualification.service.ts
 * Generated By : ianday on [DATE]
 * Date ........: [DATE]
/************/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { MasterQualification } from '../models/master-qualification'; // Import the appropriate models
import { Settings } from './settings';
import { RequestTypeQualification } from '../models/requesttypequalification';
import { CustomQualification } from '../models/custom-qualification';
import { ServiceQualification } from '../models/service-qualification';
import { ServiceQualResponse } from '../models/service-qual-response';
import { CaseQualResponse } from '../models/caseQualResponse';

@Injectable({
	providedIn: 'root'
})
export class QualificationService {

	public masterQualificationsURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/master';
	public customQualificationsURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/custom';
	private requestTypeQualificationsURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/request-type-qualifications';
	public serviceQualificationsURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/servicequalifications';
	public serviceQualResponsesURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/service-qual-responses';
	public caseQualResponsesURLPath: string = Settings.getInstance().BASE_URL + 'qualifications/case-qual-responses';


	constructor(private http: HttpClient) { }

	/** Master Qualifications **/
	getAllMasterQualifications(): Observable<any> {
		return this.http.get<any>(this.masterQualificationsURLPath)
			.pipe(
				retry(1)
			);
	}

	getMasterQualification(id: number): Observable<any> {
		return this.http.get<any>(this.masterQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	createMasterQualification(record: MasterQualification): Observable<any> {
		return this.http.post(this.masterQualificationsURLPath, record)
			.pipe(
				retry(1)
			);
	}

	updateMasterQualification(record: MasterQualification): Observable<any> {
		return this.http.put(this.masterQualificationsURLPath + '/' + record.id, record)
			.pipe(
				retry(1)
			);
	}

	deleteMasterQualification(id: number): Observable<any> {
		return this.http.delete(this.masterQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	// Methods for Requesttype-Master qualification mapping

	createRequestTypeQualification(record: RequestTypeQualification): Observable<any> {
		return this.http.post(this.requestTypeQualificationsURLPath, record)
			.pipe(
				retry(1)
			);
	}

	updateRequestTypeQualification(record: RequestTypeQualification): Observable<any> {
		return this.http.put(this.requestTypeQualificationsURLPath + '/' + record.id, record)
			.pipe(
				retry(1)
			);
	}

	deleteRequestTypeQualification(id: number): Observable<any> {
		return this.http.delete(this.requestTypeQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	getAllRequestTypeQualificationsByRequestTypeId(requestTypeId: number): Observable<any> {
		return this.http.get<any>(this.requestTypeQualificationsURLPath + '/' + requestTypeId)
			.pipe(
				retry(1)
			);
	}

	getAllRequestTypeQualificationsByMasterQualificationId(masterQualificationId: number): Observable<any> {
		return this.http.get<any>(this.requestTypeQualificationsURLPath + '/master/' + masterQualificationId)
			.pipe(
				retry(1)
			);
	}

	// Delete all RequestTypeQualifications by request type id
	deleteAllRequestTypeQualificationsByRequestTypeId(requestTypeId: number): Observable<any> {
		const url = `${this.requestTypeQualificationsURLPath}/delete-all/requesttype/${requestTypeId}`;
		return this.http.delete(url)
			.pipe(
				retry(1)
			);
	}

	// Delete all RequestTypeQualifications by master qualification id
	deleteAllRequestTypeQualificationsByMasterQualificationId(masterQualificationId: number): Observable<any> {
		const url = `${this.requestTypeQualificationsURLPath}/delete-all/master/${masterQualificationId}`;
		return this.http.delete(url)
			.pipe(
				retry(1)
			);
	}

	/************************************************/
	/** Master Qualifications **/
	/************************************************/

	getAllCustomQualifications(): Observable<any> {
		return this.http.get<any>(this.customQualificationsURLPath + '/all')
			.pipe(
				retry(1)
			);
	}

	
	getAllCustomQualificationsByAgencyId(agencyId: number): Observable<any> {
		return this.http.get<any>(this.customQualificationsURLPath + '/agency/' + agencyId)
			.pipe(
				retry(1)
			);
	}

	getCustomQualification(id: number): Observable<any> {
		return this.http.get<any>(this.customQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	createCustomQualification(record: CustomQualification): Observable<any> {
		return this.http.post(this.customQualificationsURLPath, record)
			.pipe(
				retry(1)
			);
	}

	updateCustomQualification(record: CustomQualification): Observable<any> {
		return this.http.put(this.customQualificationsURLPath + '/' + record.id, record)
			.pipe(
				retry(1)
			);
	}

	deleteCustomQualification(id: number): Observable<any> {
		return this.http.delete(this.customQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	/************************************************/
	/** Service Qualifications **/
	/************************************************/

	getAllServiceQualificationsByServiceDefId(serviceDefId: number): Observable<any> {
		return this.http.get<any>(this.serviceQualificationsURLPath + '/servicedefId/' + serviceDefId)
			.pipe(
				retry(1)
			);
	}


	createServiceQualification(record: ServiceQualification): Observable<any> {
		return this.http.post(this.serviceQualificationsURLPath, record)
			.pipe(
				retry(1)
			);
	}

	updateServiceQualification(record: ServiceQualification): Observable<any> {
		return this.http.put(this.serviceQualificationsURLPath + '/' + record.id, record)
			.pipe(
				retry(1)
			);
	}

	deleteServiceQualification(id: number): Observable<any> {
		return this.http.delete(this.serviceQualificationsURLPath + '/' + id)
			.pipe(
				retry(1)
			);
	}

	deleteAllServiceQualificationsByServiceDefId(servicedefId: number): Observable<any> {
		return this.http.delete(this.serviceQualificationsURLPath + '/servicedefId/' + servicedefId)
			.pipe(
				retry(1)
			);
	}

	getAllServiceQualResponsesByServiceRequestId(serviceRequestId: number): Observable<any> {
		return this.http.get<any>(`${this.serviceQualResponsesURLPath}/${serviceRequestId}`)
			.pipe(
				retry(1)
			);
	}

	createServiceQualResponse(response: ServiceQualResponse): Observable<any> {
		return this.http.post(this.serviceQualResponsesURLPath, response)
			.pipe(
				retry(1)
			);
	}

	updateServiceQualResponse(updatedData: Partial<ServiceQualResponse>): Observable<any> {
		return this.http.put(`${this.serviceQualResponsesURLPath}/${updatedData.id}`, updatedData)
			.pipe(
				retry(1)
			);
	}
	
	//CaseQualResponse methods
	
	
	getAllCaseQualResponsesByCaseId(caseId: number): Observable<any> {
		return this.http.get<any>(`${this.caseQualResponsesURLPath}/${caseId}`)
			.pipe(
				retry(1)
			);
	}

	createCaseQualResponse(response: CaseQualResponse): Observable<any> {
		return this.http.post(this.caseQualResponsesURLPath, response)
			.pipe(
				retry(1)
			);
	}

	updateCaseQualResponse(updatedData: CaseQualResponse): Observable<any> {
		return this.http.put(`${this.caseQualResponsesURLPath}/${updatedData.id}`, updatedData)
			.pipe(
				retry(1)
			);
	}

}
